import { useQuery, useMutation } from '@tanstack/react-query';
import { searchProducts, createCheckout, getStatus } from '@/lib/fullscript';
import type { CheckoutResult } from '@/lib/fullscript';

/** Search Fullscript catalog for products matching the given terms */
export function useProductSearch(searchTerms: string) {
  return useQuery({
    queryKey: ['fullscript-search', searchTerms],
    queryFn: () => searchProducts(searchTerms),
    enabled: !!searchTerms,
    staleTime: 5 * 60 * 1000, // 5 min cache
  });
}

/** Create a Fullscript checkout (treatment plan) */
export function useCheckout() {
  return useMutation<
    CheckoutResult,
    Error,
    Array<{
      productId: string;
      variantId: string;
      quantity: number;
      dosageInstructions: string;
    }>
  >({
    mutationFn: createCheckout,
  });
}

/** Check Fullscript connection status */
export function useFullscriptStatus() {
  return useQuery({
    queryKey: ['fullscript-status'],
    queryFn: getStatus,
    staleTime: 60 * 1000, // 1 min cache
  });
}
